import { APP_SAVE_BAR_SCOPE } from "@/modules/app-save-bar";

export const INTERVENTION_SECTION_SCOPE =
  APP_SAVE_BAR_SCOPE.INTERVENTION_SECTION_EDITOR;
